export const loadData = async (filePath) => {
  try {
    const response = await fetch(`/src/data/${filePath}`);
    if (!response.ok) {
      throw new Error(`Failed to load data from ${filePath}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error loading data:", error);
    return null;
  }
};

export const getResearchArticles = async () => {
  const data = await loadData("research.json");
  return data?.articles || [];
};

export const getTools = async () => {
  const data = await loadData("tools.json");
  return data?.tools || [];
};

export const getBlogPosts = async () => {
  const data = await loadData("blog.json");
  return data?.posts || [];
};

export const getArticleBySlug = async (slug) => {
  const articles = await getResearchArticles();
  return articles.find((article) => article.slug === slug);
};

export const getToolBySlug = async (slug) => {
  const tools = await getTools();
  return tools.find((tool) => tool.slug === slug);
};

export const getBlogPostBySlug = async (slug) => {
  const posts = await getBlogPosts();
  return posts.find((post) => post.slug === slug);
};
